import { render, staticRenderFns } from "./Ihbarname892HacizForm.vue?vue&type=template&id=0891f340&scoped=true"
import script from "./Ihbarname892HacizForm.vue?vue&type=script&lang=ts"
export * from "./Ihbarname892HacizForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0891f340",
  null
  
)

export default component.exports